// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","wrapper":"footer_wrapper__3XTBO","content":"footer_content__Qe73w","social":"footer_social__7XGwd"};